import { useSelector } from "react-redux";
import {
  getDropdownKey,
  get_metric_info_from_identifier
} from "../../Utils/chart_utils";
import { trainingAPI } from "../../api/TrainingAPI";
import { useState, useEffect, useMemo } from "react";
import { LoadingComponent } from "../Common/LoadingComponent";
import LineChartExample from "../Charts/LineChartExample";
import { mergeTestingDataByDate } from "./mergeTestingDataByDate";

export const MultiMetricChart = ({
  values,
  metricType,
  startDate,
  endDate,
  playerId,
  stat,
  position,
  player_group,
  sessions,
  showTitle = true,
  usePreloadedData = false,
  preComputedData = null,
  preComputedPlayerDataIsNotEmpty = true,
  forceTitle = "",
  showDataLabelToggle = false,
  chartIndex = 0,
  pageType = "team",
}) => {
  const {
    all_metric_types, allPlayers
  } = useSelector(({ team }) => team);
  const [metricKeys, setMetricKeys] = useState([]);
  const [statData, setStatData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [localDataIsNotEmpty, setLocalDataIsNotEmpty] = useState(true);
  const [bodyWeightOption, setBodyWeightOption] = useState(false);
  const metricDatum = useMemo(() =>
    values.map(value => get_metric_info_from_identifier(value)),
    [values]
  );

  useEffect(() => {
    const newMetricKeys = metricDatum.map(datum => datum.metric_id);
    setMetricKeys(newMetricKeys);
  }, [metricDatum]);

  const metrics = useMemo(() =>
    metricKeys.map(metricKey =>
      Object.values(all_metric_types)
        .reduce((acc, curr) => [...acc, ...curr], [])
        .find((metric) => getDropdownKey(metric, "metricId") === metricKey)
    ),
    [metricKeys, all_metric_types]
  );

  const fetchSingleStatChartData = async (metKeys) => {
    if (usePreloadedData) {
      return preComputedData;
    } else {
      let cleanKeys = metricKeys.filter(x => x !== null && x !== undefined && x !== "" && x !== "-")
      let unprocessedStatData = []
      for (let i = 0; i < cleanKeys.length; i++) {
        if (!startDate || !endDate) {
          break;
        }

        let singleStat = await trainingAPI.getTestingData({
          start_date: startDate,
          end_date: endDate,
          pos_filter: position,
          metric_type: metricType,
          stats: "",
          metric_id: cleanKeys[i],
          player_id: playerId,
          player_group: player_group,
          sessions: sessions
        });
        unprocessedStatData.push(singleStat);
      }

      if (unprocessedStatData.length === 0) return { optionsV2: [], data: [] };

      const processedStatData = mergeTestingDataByDate(unprocessedStatData);
      const mergedData = processedStatData.data;

      if (playerId) {
        processedStatData.optionsV2 = processedStatData.optionsV2.map((opt) => {
          let newOpt = { ...opt }
          const player = allPlayers.find((player) => player.player_id === playerId)
          if (player) {
            newOpt.baseline = player.bodyweight_baseline
          }

          return newOpt
        })
      }
      // Check if there's at least one non-date key with a non-null value
      const hasValidData = mergedData.some(entry => {
        return Object.entries(entry).some(([key, value]) =>
          key !== 'date' && value !== null && value !== undefined
        );
      });

      // Set the local data is not empty state
      setLocalDataIsNotEmpty(hasValidData);

      return processedStatData;
    }
  };

  const fetchStatChartData = useMemo(() => async () => {
    if (metricKeys.filter(x => x !== null || x !== undefined || x !== "" || x !== "-").length === 0) {
      setStatData({});
      return;
    }
    setLoading(true);
    try {
      const statChartData = await fetchSingleStatChartData(metricKeys);
      setStatData(statChartData);
    } catch (e) {
      setStatData({});
    }
    setLoading(false);
  }, [metricKeys, startDate, endDate, playerId, position, player_group, sessions, metricType]);

  // Function to check if any option in statData.optionsV2 has "Body Weight (Lbs)"
  const hasBodyWeightOption = () => {
    console.log("statData", statData)
    if (!statData || !statData.optionsV2 || !Array.isArray(statData.optionsV2)) {
      return false;
    }
    return (statData?.name === "Body Weight (Lbs)" || statData?.name === "Body Weight (SECA)") || statData.optionsV2.some(option => (option.name === "Body Weight (Lbs)") || (option.name === "Body Weight (SECA)"));
  };

  const hasBodyWeightAvailable = hasBodyWeightOption()
  useEffect(() => {
    fetchStatChartData();
  }, [fetchStatChartData]);


  if (metricType === "nutrition") {
    return (
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          position: "relative",
          marginBottom: 16,
          alignItems: "center",
          height: pageType === "profile" ? '100%' : null
        }}
      >
        <LoadingComponent loading={loading} title="Loading chart data...">
          <div className="fp-testing-chart" style={{ height: pageType === "profile" ? '100%' : '400px', width: pageType === "profile" ? '100%' : null }}>
            <LineChartExample
              preComputedPlayerDataIsNotEmpty={preComputedPlayerDataIsNotEmpty && localDataIsNotEmpty}
              statData={statData}
              stat={stat}
              showTitle={showTitle}
              forceTitle={forceTitle}
              showDataLabelToggle={showDataLabelToggle}
              chartIndex={chartIndex}
              pageType={pageType}
              showBodyWeightBaseline={bodyWeightOption || (pageType === "profile" && hasBodyWeightAvailable)}
              height={pageType === "profile" ? '100%' : null}
              showBodyWeightToggle={pageType !== "profile"}
              bodyWeightOption={bodyWeightOption}
              setBodyWeightOption={setBodyWeightOption}

            />
          </div>
        </LoadingComponent>
      </div>
    );
  }
  return (<></>)
};
